import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormGroup, Label } from "reactstrap";
import {
  createSupplierReceipts,
  getAllDocumentList,
  getCustomerAddressList,
  getDeductionList,
  getDeliveryMethodList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListCustomerList,
  getListMainproduct,
  getTaxList,
  viewSupplierReceipts,
  updateSupplierReceipts,
  getMaturityDatesList,
  getListSalesmenList,
  getDeliveryNotesList,
  getListSupplierList,
  getPaymentMethodList,
  getBillLandingList,
  getWaybillsList,
  getPurchaseorderList,
  getSupplierInvoiceList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";



const AddSupplierReceipts = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);

  const [supplierCreditData, setSupplierCreditData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    supplier_id: "",
    net_value: "",
    related_documents_notes: "",
    exchange_currency_id: "",
    exchange_rate: "",
    notes: "",
    status: 0,
    financial_discount: "",
    associated_documents: [],
    associate_document_type: "",
    payments: [],
  });

  const [supplierCreditViewData, setSupplierCreditViewData] = useState("");
  let errorsObj = {
    date: "",
    document_set_id: "",
    supplier_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [suppliersDataList, setSuppliersDataList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [paymentErrors, setPaymentErrors] = useState([]);
  const [paymentList, setPaymentList] = useState([]);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_supplier_receipts",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSupplierList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSuppliersDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewSupplierReceipts(data)
        .then((response) => {
          setSupplierCreditViewData(response.data.data);
        })
        .catch((err) => {
          navigate("/supplierReceipts");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (supplierCreditViewData) {
      setSupplierCreditData({
        id: supplierCreditViewData?.id,
        date: supplierCreditViewData?.date,
        document_set_id: supplierCreditViewData?.document_set_id,
        supplier_id: supplierCreditViewData?.supplier_id,
        net_value: supplierCreditViewData?.net_value,
        exchange_currency_id: supplierCreditViewData?.exchange_currency_id,
        exchange_rate: supplierCreditViewData?.exchange_rate,
        notes: supplierCreditViewData?.notes,
        status: supplierCreditViewData?.status,
        financial_discount: supplierCreditViewData?.financial_discount,
        associated_documents: supplierCreditViewData?.associated_documents,
        associate_document_type:
          supplierCreditViewData?.associate_document_type,
        related_documents_notes:
          supplierCreditViewData?.related_documents_notes,
        payments: supplierCreditViewData?.payments,
      });
    }
  }, [supplierCreditViewData]);

  useEffect(() => {
    if (!supplierCreditData?.supplier_id) {
      return;
    }

    if (Number(supplierCreditData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        supplier_id: supplierCreditData.supplier_id,
      };

      getSupplierInvoiceList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            supplier_id: item.supplier_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [supplierCreditData, supplierCreditData?.associate_document_type]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleAddPayments = () => {
    setSupplierCreditData((prev) => {
      const lastPayments = prev.payments[prev.payments?.length - 1];

      if (!lastPayments) {
        return {
          ...prev,
          payments: [{ payment_method_id: "", date: "", value: "", notes: "" }],
        };
      }

      if (
        !lastPayments.payment_method_id ||
        !lastPayments.value ||
        !lastPayments.date
      ) {
        toast.error(
          "Please complete payment method,value date, before adding another payment.",
        );
        return prev;
      }

      return {
        ...prev,
        payments: [
          ...prev.payments,
          { payment_method_id: "", date: "", value: "" },
        ],
      };
    });
  };

  const handleRemovePayments = (index) => {
    setSupplierCreditData((prev) => ({
      ...prev,
      payments: prev.payments.filter((_, i) => i !== index),
    }));
  };

  const handleChangePayments = (index, field, value) => {
    setSupplierCreditData((prev) => {
      const updatedDocs = [...prev.payments];

      if (field === "payment_method_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, payments: updatedDocs };
    });

    setPaymentErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "payment_method_id" && !value) {
        errors[index].associated_id = "Payment Method is required";
      } else if (field === "payment_method_id") {
        errors[index].payment_method_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      if (field === "date" && !value) {
        errors[index].date = "Date is required";
      } else if (field === "date") {
        errors[index].date = "";
      }

      return errors;
    });
  };

  const handleAddAssociatedDocuments = () => {
    setSupplierCreditData((prev) => {
      const lastAssociatedDocuments =
        prev.associated_documents[prev.associated_documents?.length - 1];

      if (!lastAssociatedDocuments) {
        return {
          ...prev,
          associated_documents: [{ associated_id: "", value: "" }],
        };
      }

      if (
        !lastAssociatedDocuments.associated_id ||
        !lastAssociatedDocuments.value
      ) {
        toast.error(
          "Please complete associate,value before adding another associated documents",
        );
        return prev;
      }

      return {
        ...prev,
        associated_documents: [
          ...prev.associated_documents,
          { associated_id: "", value: "" },
        ],
      };
    });
  };

  const handleRemoveAssociatedDocuments = (index) => {
    setSupplierCreditData((prev) => ({
      ...prev,
      associated_documents: prev.associated_documents.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  const handleChangeAssociatedDocuments = (index, field, value) => {
    setSupplierCreditData((prev) => {
      const updatedDocs = [...prev.associated_documents];

      if (field === "associated_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, associated_documents: updatedDocs };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "associated_id" && !value) {
        errors[index].associated_id = "Associated is required";
      } else if (field === "associated_id") {
        errors[index].associated_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      return errors;
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!supplierCreditData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierCreditData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierCreditData.supplier_id) {
      errorObj.supplier_id = `Supplier is required.`;
      error = true;
      setBtnLoader(false);
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: supplierCreditData?.date,
      document_set_id: supplierCreditData?.document_set_id,
      supplier_id: supplierCreditData?.supplier_id,
      net_value: supplierCreditData?.net_value,
      exchange_currency_id: supplierCreditData?.exchange_currency_id,
      exchange_rate: supplierCreditData?.exchange_rate,
      notes: supplierCreditData?.notes,
      status: supplierCreditData?.status,
      financial_discount: supplierCreditData?.financial_discount,
      associated_documents: supplierCreditData?.associated_documents,
      associate_document_type: supplierCreditData?.associate_document_type,
      related_documents_notes: supplierCreditData?.related_documents_notes,
      payments: supplierCreditData?.payments,
    };

    let updateData = {
      id: supplierCreditData?.id,
      document_id: supplierCreditViewData?.document_id,
      date: supplierCreditData?.date,
      document_set_id: supplierCreditData?.document_set_id,
      supplier_id: supplierCreditData?.supplier_id,
      net_value: supplierCreditData?.net_value,
      exchange_currency_id: supplierCreditData?.exchange_currency_id,
      exchange_rate: supplierCreditData?.exchange_rate,
      notes: supplierCreditData?.notes,
      status: supplierCreditData?.status,
      financial_discount: supplierCreditData?.financial_discount,
      associated_documents: supplierCreditData?.associated_documents,
      associate_document_type: supplierCreditData?.associate_document_type,
      related_documents_notes: supplierCreditData?.related_documents_notes,
      payments: supplierCreditData?.payments,
    };

    if (supplierCreditViewData?.id) {
      updateSupplierReceipts(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierReceipts");
          setSupplierCreditData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createSupplierReceipts(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierReceipts");
          setSupplierCreditData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">
                  {t("supplierReceipts")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={supplierCreditData.date}
                                  onChange={(e) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      supplierCreditData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("supplier")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={suppliersDataList}
                                  value={suppliersDataList.find(
                                    (item) =>
                                      item.value ===
                                      supplierCreditData.supplier_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      supplier_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Customer"}
                                />
                                {errors.supplier_id && (
                                  <span className="input-error">
                                    {errors.supplier_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("related_documents_notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierCreditData.related_documents_notes
                                  }
                                  onChange={(e) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      related_documents_notes: e.target.value,
                                    });
                                  }}
                                  name="related_documents_notes"
                                  placeholder="Related Documents Notes"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("net_value")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierCreditData.net_value}
                                  onChange={(e) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      net_value: e.target.value,
                                    });
                                  }}
                                  name="net_value"
                                  placeholder="Net Value"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_currency")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={exchangeCurrList}
                                  value={exchangeCurrList.find(
                                    (item) =>
                                      item.value ===
                                      supplierCreditData.exchange_currency_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      exchange_currency_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exchange Currency"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_rate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierCreditData.exchange_rate}
                                  onChange={(e) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      exchange_rate: e.target.value,
                                    });
                                  }}
                                  name="exchange_rate"
                                  placeholder="Exchange Rate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierCreditData.notes}
                                  onChange={(e) => {
                                    setSupplierCreditData({
                                      ...supplierCreditData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name="notes"
                                  placeholder="Notes"
                                  rows={3}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("status")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={supplierCreditData.status === 1}
                                    onChange={(e) => {
                                      setSupplierCreditData({
                                        ...supplierCreditData,
                                        status: e.target.checked ? 1 : 0,
                                      });
                                    }}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("status")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          {" "}
                          <h5>{t("associated_documents")}</h5>
                          <button
                            className="btn btn-primary"
                            onClick={handleAddAssociatedDocuments}
                            type="button"
                          >
                            + {t("add")}
                          </button>
                          <div className="col-md-3">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("associate_document_type")}
                              </Label>
                              <Select
                                className="my-select-v"
                                options={invoiceType}
                                value={invoiceType.find(
                                  (item) =>
                                    item.value ===
                                    supplierCreditData.associate_document_type,
                                )}
                                onChange={(selectedOption) => {
                                  setSupplierCreditData({
                                    ...supplierCreditData,
                                    associate_document_type: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  });
                                }}
                                isSearchable={true}
                                isClearable={true}
                                placeholder={"Select Document type"}
                              />
                            </FormGroup>
                          </div>
                        </div>

                        {supplierCreditData?.associated_documents?.length >
                        0 ? (
                          <div
                            className="row justify-content-start"
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                            }}
                          >
                            {supplierCreditData?.associated_documents?.map(
                              (tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("associated_documents")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={assocDataList}
                                                value={
                                                  assocDataList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.associated_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangeAssociatedDocuments(
                                                    index,
                                                    "associated_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Associate"}
                                              />
                                              {propertyErrors[index]
                                                ?.associated_id && (
                                                <small className="text-danger">
                                                  {
                                                    propertyErrors[index]
                                                      .associated_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.value}
                                                onChange={(e) =>
                                                  handleChangeAssociatedDocuments(
                                                    index,
                                                    "value",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Value"
                                              />
                                              {propertyErrors[index]?.value && (
                                                <small className="text-danger">
                                                  {propertyErrors[index].value}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemoveAssociatedDocuments(
                                              index,
                                              tax,
                                            )
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          <p className="text-muted">
                            No Associated documents list added.
                          </p>
                        )}
                      </div>

                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          {" "}
                          <h5>{t("payments")}</h5>
                          <button
                            className="btn btn-primary"
                            onClick={handleAddPayments}
                            type="button"
                          >
                            + {t("add")}
                          </button>
                        </div>

                        {supplierCreditData?.payments?.length > 0 ? (
                          <div
                            className="row justify-content-start"
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                            }}
                          >
                            {supplierCreditData?.payments?.map((tax, index) => (
                              <div className="col-md-6">
                                <div className="fileupload-content px-4">
                                  <div
                                    className="row justify-content-start align-items-center mb-2"
                                    key={index}
                                  >
                                    <div className="col-md-6">
                                      <FormGroup>
                                        <Label className="col-form-label form-label">
                                          {t("payments")}
                                        </Label>
                                        <div className="col-xl-12">
                                          <div className="input-div">
                                            <Select
                                              className="my-select-v"
                                              options={paymentList}
                                              value={
                                                paymentList.find(
                                                  (item) =>
                                                    item.value ===
                                                    tax.payment_method_id,
                                                ) || null
                                              }
                                              onChange={(selectedOption) => {
                                                handleChangePayments(
                                                  index,
                                                  "payment_method_id",
                                                  selectedOption
                                                    ? selectedOption.value
                                                    : "",
                                                );
                                              }}
                                              isSearchable={true}
                                              isClearable={true}
                                              placeholder={"Select Payment"}
                                            />
                                            {paymentErrors[index]
                                              ?.payment_method_id && (
                                              <small className="text-danger">
                                                {
                                                  paymentErrors[index]
                                                    .payment_method_id
                                                }
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </FormGroup>
                                    </div>

                                    <div className="col-md-6">
                                      <FormGroup>
                                        <Label className="col-form-label form-label">
                                          {t("date")}
                                        </Label>
                                        <div className="col-xl-12">
                                          <div className="input-div">
                                            <input
                                              className="form-control input-search"
                                              type="date"
                                              value={tax?.date}
                                              onChange={(e) =>
                                                handleChangePayments(
                                                  index,
                                                  "date",
                                                  e.target.value,
                                                )
                                              }
                                              placeholder="Date"
                                            />
                                            {paymentErrors[index]?.date && (
                                              <small className="text-danger">
                                                {paymentErrors[index].date}
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </FormGroup>
                                    </div>

                                    <div className="col-md-6">
                                      <FormGroup>
                                        <Label className="col-form-label form-label">
                                          {t("value")}
                                        </Label>
                                        <div className="col-xl-12">
                                          <div className="input-div">
                                            <input
                                              className="form-control input-search"
                                              type="number"
                                              value={tax?.value}
                                              onChange={(e) =>
                                                handleChangePayments(
                                                  index,
                                                  "value",
                                                  e.target.value,
                                                )
                                              }
                                              placeholder="Value"
                                            />
                                            {paymentErrors[index]?.value && (
                                              <small className="text-danger">
                                                {paymentErrors[index].value}
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </FormGroup>
                                    </div>

                                    <div className="col-md-6">
                                      <FormGroup>
                                        <Label className="col-form-label form-label">
                                          {t("notes")}
                                        </Label>
                                        <div className="col-xl-12">
                                          <div className="input-div">
                                            <textarea
                                              className="form-control input-search"
                                              type="text"
                                              value={tax.notes}
                                              onChange={(e) =>
                                                handleChangePayments(
                                                  index,
                                                  "notes",
                                                  e.target.value,
                                                )
                                              }
                                              placeholder="Notes"
                                            />
                                          </div>
                                        </div>
                                      </FormGroup>
                                    </div>

                                    <div className="d-flex align-items-center">
                                      <button
                                        className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                        onClick={() =>
                                          handleRemovePayments(index, tax)
                                        }
                                        type="button"
                                      >
                                        <i className="bi bi-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-muted">No Payment list added.</p>
                        )}
                      </div>

                      <div className="row">
                        <div className="col ms-2">
                          <button
                            type="button"
                            className="back-btn"
                            onClick={() => navigate("/supplierReceipts")}
                          >
                            <i className="bi bi-arrow-left"> </i> {t("back")}
                          </button>
                        </div>
                        <div className="col">
                          <div className="d-flex justify-content-end nxt-btn">
                            {btnLoader === true ? (
                              <button type="submit" className="btn btn-primary">
                                Loading...
                              </button>
                            ) : (
                              <button type="submit" className="btn btn-primary">
                                {t("submit")} <i className="bi bi-check2"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddSupplierReceipts;
